import $ from 'jquery';
import { runProtectedRoute } from '../middleware';
import {
  initOnModalServiziEvents,
  hideSpinner,
  initScrollToTopArrow,
  initLoaderClickListeners,
} from '~loader/loader-utils';
import { renderLoader } from '~loader/renderLoader';
import { initPlayYouTubeModal } from '~src/help';
import Swal from 'sweetalert2';
import { getUser } from '~src/user';
import pRetry from 'p-retry';
import { isFeatureEnabled } from '../../features';
import { addGiottoV2BetaAnnouncement } from '../../announcements';

export const loaderRoute = async ({ params }) => {
  if (params && params.refreshUser === 'true') {
    Swal.fire({
      text: 'Stiamo aggiornando il tuo account...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await pRetry(
      async () => {
        const response = await getUser({}, true);

        if (response.user.tipo_istanza === 'demo') {
          throw new Error('Org not updated yet');
        }

        return response;
      },
      {
        retries: 10,
        onFailedAttempt: (error) => {
          console.log(
            `Attempt ${error.attemptNumber} failed. There are ${error.retriesLeft} retries left.`
          );
        },
      }
    );

    Swal.hideLoading();
    Swal.fire({
      title: 'Fatto!',
      text: 'Adesso puoi utilizzare Giotto nel pieno delle sue funzionalità',
      icon: 'success',
      confirmButtonColor: '#278e8e',
    });
  }

  const ready = await runProtectedRoute();
  if (!ready) return;

  hideSpinner();

  $('.editor-route').hide();
  $('#route-loader').show();

  initScrollToTopArrow();

  // Show Giotto 2.0 beta promo (only for flagged users)
  try {
    const canSeeGiottoV2 = await isFeatureEnabled('giotto.v2_beta_group', true);
    if (canSeeGiottoV2) {
      addGiottoV2BetaAnnouncement();
    }
  } catch (e) {
    // Silently ignore feature resolution issues for this optional promo
    console.warn('Unable to resolve giotto.v2_beta_group flag', e);
  }

  initOnModalServiziEvents();

  initPlayYouTubeModal();
  initLoaderClickListeners();

  await renderLoader();
};
